export class REVISAL_ROUTES {
	static ROOT: string = '/revisal';
	static ROOT_1: string = 'revisal';

	static CLIENTS: string = 'clients';
	static REVISAL_REQUESTS: string = 'revisal-requests'
}